module.exports = __webpack_public_path__ + "img/icon-el.8d2a15ca.svg";